module.exports = __webpack_public_path__ + "static/img/IMG_20150823_111850.384fd769.jpg";